$('.notes-btn').click(function() {
    $('.notes-holder').slideToggle();
    $(this).toggleClass("toggled");
});

// $("-").click(function(){
//     $("p").slideToggle();
// });